module.exports = __webpack_public_path__ + "media/images/member_del-9c0fc2b9a73eb0ecbb6333710fd6d4d4.svg";